import { objectToFormData } from 'utils/object-to-formdata'
import { ApiProvider, MapServerProvider } from 'providers/request'
import {
  Project,
  CreateProjectParams,
  ProjectTableFilters,
  ProjectsResponse,
  Area,
  CreateAreaParams,
} from 'models/project'
import { UrlUtils } from 'utils/url'

export const ProjectRepository = {
  fetchAll(filters: ProjectTableFilters): Promise<ProjectsResponse> {
    const queryParams = UrlUtils.formatQueryParams(filters)
    return ApiProvider.get(`/projects?${queryParams}`)
  },

  getRecent(): Promise<ProjectsResponse> {
    const filters: ProjectTableFilters = {
      offset: 0,
      limit: 3,
      q: '',
      sortBy: 'updatedAt_desc',
    }
    const queryParams = UrlUtils.formatQueryParams(filters)

    return ApiProvider.get(`/projects?${queryParams}`)
  },

  delete(id: string): Promise<any> {
    return ApiProvider.delete(`/projects/${id}`)
  },

  duplicate(id: string): Promise<Project> {
    return ApiProvider.post(`/projects/${id}/duplicate`)
  },

  create(params: CreateProjectParams): Promise<Project> {
    const { file, ...data } = params
    const formData = objectToFormData({ file, data: JSON.stringify(data) })
    return ApiProvider.post('/projects', formData)
  },

  createPondera(params: CreateProjectParams): Promise<Project> {
    const { file, ...data } = params
    const formData = objectToFormData({ file, data: JSON.stringify(data) })
    return ApiProvider.post('/projects/pondera', formData)
  },

  fetchById(id: string): Promise<Project> {
    return ApiProvider.get(`/projects/${id}`)
  },

  update(id: string, data: Partial<Project>): Promise<Project> {
    const formData = objectToFormData({ data: JSON.stringify(data) })
    return ApiProvider.patch(`/projects/${id}`, formData)
  },

  changeArea(id: string, params: CreateProjectParams): Promise<Project> {
    const { file, ...data } = params
    const formData = objectToFormData({ file, data: JSON.stringify(data) })
    return ApiProvider.patch(`/projects/${id}`, formData)
  },

  fetchAreas(projectId: string): Promise<Area[]> {
    return ApiProvider.get(`/projects/${projectId}/areas`)
  },

  deleteArea(projectId: string, areaId?: string): Promise<any> {
    return ApiProvider.delete(`/projects/${projectId}/areas/${areaId}`)
  },

  createArea(projectId: string, params: CreateAreaParams): Promise<Area> {
    const { file, ...data } = params
    const formData = objectToFormData({ file, data: JSON.stringify(data) })
    return ApiProvider.post(`/projects/${projectId}/areas`, formData)
  },

  generateReport(projectId: string, areaId?: string): Promise<File> {
    return MapServerProvider.post(`/generateReport`, { projectId, areaId })
  },
}
